<template>
  <div>
    <div @click="wipeValue" class="mb-4 relative">
      <input
        ref="input"
        class="input border-solid border border-gray-500 appearance-none rounded w-full px-3 py-1 pt-2 focus focus:shadow-outline focus:border-indigo-600 focus:outline-none active:outline-none active:border-indigo-600"
        v-model="localValue"
        @input="$emit('input', localValue)"
        type="text">
      <label
        class="inset-0 transition ease-in duration-200 absolute mb-0 leading-tighter cursor-text"
        :class="localValue !== '' ? 'text-xs font-medium text-gray-600 -mt-4 pl-1 block' : 'pt-2 pl-3 text-base text-gray-400'"
        @click="focus">
        {{localValue !== '' ? label : inputLabel}}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: ['hint', 'label', 'value', 'wipe'],
  model: {
    prop: 'value'
  },
  data () {
    return {
      inputLabel: this.label || '',
      localValue: this.value || ''
    }
  },
  methods: {
    focus () {
      this.$refs.input.focus()
    },
    wipeHint (e) {
      console.log('blur', e.target)
    },
    wipeValue () {
      if (this.wipe) {
        this.localValue = ''
        if (this.hint) this.inputLabel = this.hint
      }
    }
  }
}
</script>